import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { ErrorModal } from '@futures-platform/ui'
import { clearAllErrors } from '../actions/radarSettings'

export default connect(
    state => {
        const {
            errors
        } = state

        return {
            errors
        }
    },
    dispatch => bindActionCreators({
        onClose: clearAllErrors
    }, dispatch)
)(ErrorModal)
